import { render, staticRenderFns } from "./showNotificationInteractionComponent.vue?vue&type=template&id=0cad8c8a&scoped=true&"
import script from "./showNotificationInteractionComponent.vue?vue&type=script&lang=js&"
export * from "./showNotificationInteractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./showNotificationInteractionComponent.vue?vue&type=style&index=0&id=0cad8c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad8c8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VChip,VCol,VDivider,VIcon,VRow,VSimpleTable,VTextField,VTextarea})
